export default __webpack_public_path__ + "static/media/beer-keg.3319ca21.jpg";